export default class OperatingSystemUtil {
	static isMac(): boolean {
		return window.navigator.platform.toLowerCase().startsWith("mac");
	}
}